module.exports = __webpack_public_path__ + "img/Profit.0aafe6de.svg";